import { useFormField } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { TitleText } from '@calendly/ui/components/typography';
import { useEffect } from 'react';
import { getAvailabilityFromRule } from 'components/event_type_edit';
import { V4DateSpecificHours } from './v4_date_specific_hours';
import { V4EditAvailabilityButton } from './v4_edit_availability_button';
import { V4IntervalsSection } from './v4_intervals_section';
import { V4TimezoneDropdown } from './v4_timezone_dropdown';
import { useAvailabilitySidePanelActions } from '../available_hours/components/availability_side_panel';
import { CalendarViewControl } from '../available_hours/components/calendar_view_control';
import { MoreOptions } from '../available_hours/components/schedule_controls/more_options';
const scheduleCardCss = "sqwrliq";

/* Figma Available hours: p layoutGridMarginSmall (16px), gap spacing1_5x (24px). */
const scheduleCardBodyCss = "s1gamuxh";
const weeklyHoursHeaderCss = "w4arxcr";
const weeklyHoursActionsCss = "w1jiakgb";
const scheduleCardFooterCss = "s1cszvq5";
export const V4ScheduleCard = ({
  formPath,
  isLocked = false,
  isReadOnly = false,
  onViewCalendarInPreview,
  isCalendarPreviewActive = false,
  onClearCalendarPreview
}) => {
  const isReadOnlyState = isLocked || isReadOnly;
  const [{
    value = {}
  }, _, {
    setValue
  }] = useFormField({
    name: formPath
  });
  const {
    userId,
    ownerAvailabilityRules,
    usingCustomHours
  } = value;
  const primaryRuleId = ownerAvailabilityRules?.primaryRuleId || ownerAvailabilityRules?.primary_rule_id;
  const primarySchedule = (ownerAvailabilityRules?.rules || []).find(({
    id
  }) => id === primaryRuleId);
  const {
    toggleAvailabilitySidePanel
  } = useAvailabilitySidePanelActions();
  const hasPersistentPreview = Boolean(onViewCalendarInPreview);
  useEffect(() => {
    if (!usingCustomHours && onClearCalendarPreview) {
      onClearCalendarPreview();
    }
  }, [usingCustomHours, onClearCalendarPreview]);
  const handleRollbackToDefault = () => {
    if (!primarySchedule) return;
    onClearCalendarPreview?.();
    setValue({
      ...value,
      usingCustomHours: false,
      usingSecondarySchedule: true,
      activeAvailabilityRuleId: primarySchedule.id,
      ...getAvailabilityFromRule(primarySchedule)
    });
  };
  const showWeeklyActions = !isReadOnlyState && usingCustomHours;
  const isSharedScheduleView = isReadOnlyState || !usingCustomHours;
  const handleOpenCalendar = () => {
    if (hasPersistentPreview) {
      onViewCalendarInPreview(formPath);
      return;
    }
    toggleAvailabilitySidePanel({
      formPath,
      format: 'calendar'
    });
  };
  return <div className={scheduleCardCss} data-testid="v4-schedule-card">
      <div className={scheduleCardBodyCss}>
        {!isSharedScheduleView && <div className={weeklyHoursHeaderCss}>
            <TitleText level={3} size="small">
              {I18n.t('publisher.event_type_editor.sections.available_hours.weekly_hours')}
            </TitleText>
            {showWeeklyActions && <div className={weeklyHoursActionsCss}>
                <CalendarViewControl variant="v4" isActive={isCalendarPreviewActive} onClick={handleOpenCalendar} />
                <MoreOptions handleRollbackToDefault={handleRollbackToDefault} userId={userId} variant="v4" />
              </div>}
          </div>}
        <V4IntervalsSection formPath={formPath} readOnly={isReadOnlyState} />
        <V4DateSpecificHours formPath={formPath} readOnly={isSharedScheduleView} />
      </div>
      <div className={scheduleCardFooterCss}>
        <V4TimezoneDropdown formPath={formPath} readOnly={isSharedScheduleView} />
        {!isReadOnlyState && !usingCustomHours && <V4EditAvailabilityButton formPath={formPath} />}
      </div>
    </div>;
};

require("./v4_schedule_card.wyw-in-js.css!=!../../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./v4_schedule_card.js");